export default __webpack_public_path__ + "static/media/paypalLogo.93ff7ed0.png";